// extracted by mini-css-extract-plugin
export default {"wrapper":"Carousel_wrapper__IIfBc","transitionable":"Carousel_transitionable__muVS8","carousel__count":"Carousel_carousel__count__MIl0b"};